import CategoryContentView from '@/views/CategoryContent/CategoryContent';
import { GetServerSidePropsContext } from 'next';

export default function CategoryContent() {
  return <CategoryContentView />;
}

export const getServerSideProps = ({ locale, params }: GetServerSidePropsContext) => ({
  props: { locale, params },
});
